<template>
  <v-flex class="pl-2 pr-2">
    <v-layout align-start justify-start row class="ml-3 mb-4">
      <v-icon color="primary" style="font-size: 50px;">assessment</v-icon>
      <h2
        :style="`color: ${$vuetify.theme.primary}`"
        class="mt-2 ml-2"
      >Sales and Fees</h2>
    </v-layout>
    <v-layout row wrap justify-space-around>
      <v-flex xs3>
        <v-text-field
          append-icon="search"
          label="Sale number"
          single-line
          hide-details
          @input="filterSearch"
        ></v-text-field>
      </v-flex>

<!--      <v-flex xs3>-->
<!--        <v-select :items="statuses" label="Sale status" @change="filterStatus"></v-select>-->
<!--      </v-flex>-->

      <v-flex xs3>
        <v-select
          v-model="selectedPartner"
          :items="partnerObjs"
          item-text="PartnerName"
          item-value="PartnerId"
          label="Partner"
          @change="getSales"
          return-object
          :disabled="!admin"
        ></v-select>
      </v-flex>

      <v-flex xs12>
        <v-data-table
          :headers="headers"
          :items="sales"
          item-key="name"
          :search="filters"
          :custom-filter="customFilter"
        >
          <template slot="headers" slot-scope="props">
            <tr>
              <th v-for="header in props.headers" :key="header.text">{{ header.text }}</th>
            </tr>
          </template>

          <template slot="items" slot-scope="props">
            <tr class="center_table">
              <td>{{ props.item.Date }}</td>
              <td>{{ props.item.SaleBillNumber }}</td>
              <td>€ {{ props.item.VatAmount }}</td>
              <td>€ {{ props.item.Amount }}</td>
<!--              <td>-->
<!--                <center>-->
<!--                  <v-chip-->
<!--                    v-if="props.item.Status == 'OPEN'"-->
<!--                    color="red"-->
<!--                    text-color="white"-->
<!--                    small-->
<!--                  >OPEN</v-chip>-->

<!--                  <v-chip-->
<!--                    v-if="props.item.Status == 'PAID'"-->
<!--                    color="green"-->
<!--                    outline-->
<!--                    small-->
<!--                    disabled-->
<!--                    text-color="green"-->
<!--                  >PAID</v-chip>-->
<!--                </center>-->
<!--              </td>-->
              <td>
                <v-icon @click="getSaleDetailsForPDF(props.item)">picture_as_pdf</v-icon>
              </td>
              <td>
                <v-icon v-if="props.item.SaleCsv !== 'NULL' && props.item.SaleCsv !== ''" @click="getSaleDetailsForCSV(props.item)">description</v-icon>
              </td>
              <td>
                <v-icon v-if="props.item.FeeCsv !== 'NULL' && props.item.FeeCsv !== ''" @click="getFeeDetailsForCSV(props.item)">description</v-icon>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-flex>
</template>

<script>
import * as dssRequest from "@/api/dssRequest";
import appConfig from "../../../config/app_config";
import BaseObject from "@/objects/BaseObject";
import _ from "lodash";
import { mapGetters } from "vuex";
import pdfMake from "pdfmake";
import * as pdfFonts from "pdfmake/build/vfs_fonts";

export default {
  name: "Financial_Sales",
  components: {},
  computed: mapGetters({
    currentAccountId: "getCurrentAccountId"
  }),
  data() {
    return {
      filters: {
        search: "",
        Status: ""
      },

      statuses: ["All", "Open", "Paid"],

      partnerObjs: [],
      selectedPartner: {},

      sales: [],
      saleDetails: [],
      saleAttachment: [],
      saleInfo: {},
      admin: false,

      csvContent: "",

      headers: [
        {
          text: "Date",
          align: "left",
          value: "Date",
          sortable: false
        },
        {
          text: "Ref number",
          value: "SaleBillNumber",
          align: "left",
          sortable: false
        },
        {
          text: "VAT",
          value: "VAT",
          align: "left",
          sortable: false
        },
        {
          text: "Amount",
          value: "Amount",
          align: "left",
          sortable: false
        },
        // {
        //   text: "Status",
        //   value: "Status",
        //   align: "left",
        //   sortable: false
        // },
        {
          text: "Download Summary",
          value: "",
          align: "left",
          sortable: false
        },
        {
          text: "Details sales",
          value: "",
          align: "left",
          sortable: false
        },
        {
          text: "Details fees",
          value: "",
          align: "left",
          sortable: false
        }
      ]
    };
  },

  mounted() {
    if (this.$store.getters["auth/userLevel"] >= 9)
      this.admin = true;

    this.getPartners();
  },

  methods: {
    getPartners() {
      // Action for loading all the Partners in the current account
      const payload = {
        FunctionId: "AccountFunctionLibrary::getPartners"
      };
      dssRequest.doRequest(
        response => {
          console.log("the call for getPartners was successful", response);
          // Clear the current partners array
          this.partnerObjs = [];

          // Insert PartnerId to each partner object
          for (let [k, v] of Object.entries(response.data.Partners)) {
            let partnerTmp = {};
            partnerTmp['PartnerId'] = Number(k);
            partnerTmp['PartnerName'] = v.Name;
            this.partnerObjs.push(partnerTmp);

            if (!this.admin)
            {
              if(Number(k) === Number(this.$store.getters["auth/partnerId"]))
                this.selectedPartner = Object.assign({}, partnerTmp);
            }
          }

          // Sort partners by PartnerName
          this.partnerObjs.sort(function(a, b) {
            let nameA = a.PartnerName.toUpperCase(); // ignore upper and lowercase
            let nameB = b.PartnerName.toUpperCase(); // ignore upper and lowercase
            if (nameA < nameB)
              return -1;

            if (nameA > nameB)
              return 1;

            return 0;
          });

          if (this.admin)
            this.selectedPartner = Object.assign({}, this.partnerObjs[0]);

          this.getSales();
        },
        error => {
          console.log("the call for getPartners was not successful", error);
        },
        "communicateWithDBLibrary",
        this.currentAccountId,
        payload
      );
    },

    getSales() {
      console.log("this.selectedPartner: ", this.selectedPartner);
      // Get all the sales (basic info) for a partner
      const payload = {
        FunctionId: "AccountFunctionLibrary::getSalesBillsForPartner",
        PartnerId: this.selectedPartner.PartnerId,
      };

      dssRequest.doRequest(
        response => {
          console.log(
            "The call for getSalesBillsForPartner was successful",
            response
          );
          this.sales = BaseObject._createArrayWithObjects(response.data.SalesBills);
          for (var i = 0; i < this.sales.length; i++) {
            if (this.sales[i].Amount.split(".")[1] == null)
              this.sales[i].Amount += ".00";
            else if (this.sales[i].Amount.split(".")[1].length == 1)
              this.sales[i].Amount += "0";
          }
          console.log("Brian this.sales", this.sales);
        },
        error => {
          console.log(
            "The call for getSalesBillsForPartner was not successful ",
            error
          );
        },
        "communicateWithDBLibrary",
        this.currentAccountId,
        payload
      );
    },

    getSaleDetailsForPDF(item) {

      if (item.hasOwnProperty('SaleBillPdf')) {
        const source = "data:application/pdf;base64," + item.SaleBillPdf;
        const downloadLink = document.createElement("a");
        const fileName = "Sales_" + item.SaleBillNumber + ".pdf";
        downloadLink.href = source;
        downloadLink.download = fileName;
        downloadLink.click();

        let pdfWindow = window.open('');
        setTimeout(() => {
          pdfWindow.document.write(
            "<iframe width='100%' name='text' height='100%' src='data:application/pdf;base64, " +
            encodeURI(item.SaleBillPdf) + "'></iframe>")
          pdfWindow.document.title = fileName;
        }, 0);
      }
    },
    getFeeDetailsForCSV(item) {
      if (item.hasOwnProperty('FeeCsv')) {
        const source = "data:application/octet-stream;base64," + item.FeeCsv;
        const downloadLink = document.createElement("a");
        const fileName = "Fees_" + item.SaleBillNumber + ".csv";
        downloadLink.href = source;
        downloadLink.download = fileName;
        downloadLink.click();
      }
    },
    getSaleDetailsForCSV(item) {
      if (item.hasOwnProperty('SaleCsv')) {
        const source = "data:application/octet-stream;base64," + item.SaleCsv;
        const downloadLink = document.createElement("a");
        const fileName = "Sales_" + item.SaleBillNumber + ".csv";
        downloadLink.href = source;
        downloadLink.download = fileName;
        downloadLink.click();
      }
    },


    customFilter(items, filters, filter, headers) {
      // Init the filter class.
      const cf = new this.$MultiFilters(items, filters, filter, headers);

      cf.registerFilter("search", function(searchWord, items) {
        if (searchWord.trim() === "") return items;

        return items.filter(item => {
          return item.Component.toLowerCase().includes(
            searchWord.toLowerCase()
          );
        }, searchWord);
      });

      cf.registerFilter("Status", function(Status, items) {
        if (Status.trim() === "") return items;

        return items.filter(item => {
          return item.Status.toLowerCase() === Status.toLowerCase();
        }, Status);
      });

      // Its time to run all created filters.
      // Will be executed in the order they were defined.
      return cf.runFilters();
    },

    /**
     * Handler when user input something at the "Filter" text field.
     */
    filterSearch(val) {
      this.filters = this.$MultiFilters.updateFilters(this.filters, {
        search: val
      });
    },

    /**
     * Handler when user select some Status at the "Status" select.
     */
    filterStatus(val) {
      if (val == "All") {
        val = "";
      }
      this.filters = this.$MultiFilters.updateFilters(this.filters, {
        Status: val
      });
    }
  }
};
</script>

<style lang="scss", scoped>
.center_table > td {
  text-align: center;
}
</style>
